import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';
import {startWith, switchMap, switchMapTo, take, tap} from 'rxjs/operators';

import {LpHoldingService} from '../../shared/holdings/lp-holding.service';
import {LpPaymentRequestService} from '../../lp-top-notification/lp-payment-request.service';
import {TerraUtils} from '../../../shared/TerraUtils';
import {PendingPaymentRequestResponse} from '../../../shared/models/PendingPaymentRequestResponse.model';

@Component({
  selector: 'terra-lp-holding-capital-call-tab',
  templateUrl: './lp-holding-capital-call-tab.component.html',
  styleUrls: ['./lp-holding-capital-call-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LpHoldingCapitalCallTabComponent implements OnInit {
  private _refreshPaymentRequests$ = new Subject();
  isLoading$ = new BehaviorSubject(false);
  holdingId$ = this.holdingService.holdingId$;
  pendingPaymentRequests$ = this._refreshPaymentRequests$.pipe(
    startWith(''),
    switchMapTo(this.holdingId$),
    tap(_ => this.isLoading$.next(true)),
    switchMap(holdingId => this.paymentRequestService.getPaymentRequestsForHolding(holdingId)),
    tap(paymentRequests => {
      this.isLoading$.next(false);
      if (!!paymentRequests && paymentRequests.length > 0) {
        // wait a bit for the component to render
        setTimeout(() => {this.paymentRequestService.scrollToPaymentRequest(); }, 100);
        this.markPaymentRequestsAsViewed(paymentRequests);
      }
    })
  );

  constructor(private paymentRequestService: LpPaymentRequestService,
              private holdingService: LpHoldingService) {
  }

  ngOnInit(): void {
  }

  public refresh() {
    this._refreshPaymentRequests$.next(undefined);
    this.paymentRequestService.refreshPendingPaymentRequests();
  }

  private markPaymentRequestsAsViewed(paymentRequests: PendingPaymentRequestResponse[]) {
    if (!!paymentRequests && paymentRequests.length > 0) {
      const paymentTokens = paymentRequests.map(paymentRequest => paymentRequest.paymentToken);
      this.paymentRequestService.markPaymentRequestsAsViewed(paymentTokens).pipe(
        take(1)
      ).subscribe();
    }
  }
}
